const ITEMS = [
  "سکه کازرانی",
  "مرجع رسمی استعلام آنلاین نرخ سکه و طلا",
  "تضمین اصالت و پلمپ معتبر اتحادیه",
  "خرید و فروش سکه‌های پارسیان",
  "نرخ‌گذاری شفاف بر مبنای اتحادیه طلا",
];

const Row = () => (
  <div className="flex shrink-0 items-center" dir="rtl">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <span className="px-8 text-sm font-light tracking-wide text-amber-200/70 sm:text-base">{t}</span>
        <span className="text-amber-500/60">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-amber-500/15 bg-black/40 py-5" dir="ltr">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
